// extracted by mini-css-extract-plugin
export var OnTop = "OnTop-module--OnTop--zDD+-";
export var Line = "OnTop-module--Line--zrW7R";
export var LineHover = "OnTop-module--LineHover--66X7a";
export var Text = "OnTop-module--Text--vZZOd";
export var arrowLeft = "OnTop-module--arrowLeft--A8BpS";
export var arrowRight = "OnTop-module--arrowRight--lWvzc";